import React from 'react';
import { useFormContext } from 'react-hook-form';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import { NotPrimaryIcon, PrimaryIcon } from '@/assets/images';

function PrimarySetterButton({ className, disabled, index, name }) {
  const { setValue, watch } = useFormContext();
  const fields = watch(name);

  const onClick = () => {
    setValue(
      name,
      fields.map((field, i) => ({ ...field, primary: i === index })),
    );
  };

  return (
    <IconButton
      className={className}
      disabled={disabled}
      onClick={onClick}
      type="button"
    >
      {fields[index].primary ? <PrimaryIcon /> : <NotPrimaryIcon />}
    </IconButton>
  );
}

PrimarySetterButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
};

PrimarySetterButton.defaultProps = {
  className: '',
};

export default PrimarySetterButton;
